import {
  getInvestigationContent,
  investigationScopeLabels,
  type ChatInvestigation,
} from "../../../shared/chatInvestigation";
import { AttachmentPreview } from "../AttachmentPreviews";
import { Icon } from "../Icon";
import { Text } from "../Text";
import { Tooltip } from "../Tooltip";

export function ChatInvestigationSource({
  context,
  onRemove,
  readOnly = false,
}: {
  context: ChatInvestigation;
  onRemove: () => void;
  readOnly?: boolean;
}) {
  const content = getInvestigationContent(context.surface);
  if (!content) return null;
  const scope = investigationScopeLabels[context.scope];
  const period = context.period ?? content.period;
  return (
    <Tooltip
      content={`${scope} · ${period}${readOnly ? "" : " · Remove context"}`}
    >
      <AttachmentPreview
        onPress={onRemove}
        disabled={readOnly}
        aria-label={`Remove ${content.sourceTitle} context`}
      >
        <span className="file-icon">
          <Icon name="scan-heart" size={10} />
        </span>
        <span className="remove-icon">
          <Icon name="x" size={10} />
        </span>
        <Text variant="text-small-md" ellipsis>
          {content.sourceTitle}
        </Text>
      </AttachmentPreview>
    </Tooltip>
  );
}
